<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-shield-alt"></i>  {{ "TITLE.ADD-PERMISSION" | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="authorityForm">
      <div class="form-row">
        <div class="form-group col-md-10">
          <label for="moduleInput"><b>{{ "LABEL.MODULE" | translate }}</b></label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fas fa-cube"></i></div>
            </div>
            <select id="moduleInput"
                    class="form-control"
                    formControlName="module"
                    [(ngModel)]="authority.module"
                    [class.is-invalid]="isInvalidControl('module')">
              <option *ngFor="let module of modules" [ngValue]="module.id">{{module.description | translate}}</option>
            </select>
          </div>
          <small *ngIf="isInvalidControl('module')"
                 class="text-danger">
            {{ "MESSAGE.SELECT-MODULE" | translate }}
          </small>
        </div>
        <div class="form-group col-md-2 text-start">
          <label class="font-weight-bold" for="onlySuperadminCheckbox">{{ "LABEL.SUPER-ADMIN" | translate }}</label>
          <div class="custom-control custom-checkbox custom-text-align">
            <input type="checkbox"
                   class="custom-control-input"
                   id="onlySuperadminCheckbox"
                   [(ngModel)]="authority.onlySuperadmin"
                   formControlName="onlySuperadmin">
            <label class="custom-control-label" for="onlySuperadminCheckbox"></label>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="codeInput"><b>{{ "LABEL.CODE" | translate }}</b></label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fab fa-codepen"></i></div>
          </div>
          <input type="text"
                 id="codeInput"
                 class="form-control"
                 placeholder="{{ 'MESSAGE.ENTER-PERMISSION-CODE' | translate }}"
                 [(ngModel)]="authority.code"
                 formControlName="code"
                 [class.is-invalid]="isInvalidControl('code')">
        </div>
        <small *ngIf="isInvalidControl('code')"
               class="text-danger">
          {{ "MESSAGE.ENTER-PERMISSION-CODE" | translate }}
        </small>
      </div>
      <div class="form-group">
        <label for="descriptionInput"><b>{{ "LABEL.DESCRIPTION" | translate }}</b></label>
        <textarea type="text"
                  id="descriptionInput"
                  class="form-control"
                  placeholder="{{ 'MESSAGE.ENTER-PERMISSION-DESCRIPTION' | translate }}"
                  [(ngModel)]="authority.description"
                  formControlName="description"
                  [class.is-invalid]="isInvalidControl('description')">
        </textarea>
        <small *ngIf="isInvalidControl('description')"
               class="text-danger">
          {{ "MESSAGE.ENTER-PERMISSION-DESCRIPTION" | translate }}
        </small>
      </div>
      <div class="row">
        <div class="col" *ngIf="!isNewAuthority">
          <label for="state" class="col-form-label">{{ "LABEL.STATE" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="{{isActive ? 'input-group-text': 'input-group-text-danger' }}"><i
                class="{{isActive ? 'fas fa-toggle-on': 'fas fa-toggle-off' }}"></i></div>
            </div>
          <select class="form-control"
                  id="state"
                  formControlName="status"
                  [(ngModel)]="authority.active"
                  [class.is-invalid]="isInvalidControl('status')">
            <option [value]="1">{{ "LABEL.ACTIVE" | translate }}</option>
            <option [value]="0">{{ "LABEL.INACTIVE" | translate }}</option>
          </select>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="save()">
      <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger" (click)="cancel()">
      <i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
